import { render, staticRenderFns } from "./CalificacionesForm.vue?vue&type=template&id=7405ce5d"
import script from "./CalificacionesForm.vue?vue&type=script&lang=js"
export * from "./CalificacionesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports